import http from "@/utils/axios";
import { notify } from "@kyvg/vue3-notification";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    observer: [],
    access: [],
    observerCount: null,
    errors: [],
    pagination: {
      currentPage: 1,
      total: 1,
    },
    statuses: [
      {
        id: 1,
        name: "active",
      },
      {
        id: 3,
        name: "blocked",
      },
    ],
    search: "",
    currentObserver: {
      first_name: "",
      last_name: "",
      full_name: "",
      phone_number: "",
      national_number: "",
      country: "",
      country_code: "",
      email: "",
      status: "",
      created_at: "",
      updated_at: "",
      access: [],
    },
  },
  getters: {
    getUsers: (state) => state.observer,
    getUsersCount: (state) => state.observerCount,
    getErrors: (state) => state.errors,
    getPagination: (state) => state.pagination,
    getSearch: (state) => state.search,
    getCurrentUser: (state) => state.currentObserver,
    getStatuses: (state) => state.statuses,
    getStatusById: (state) => (id) => {
      return state.statuses.find((status) => status.id === id);
    },
    getAllAccess: (state) => {
      return state.access;
    },
  },
  mutations: {
    setUsers(state, users) {
      state.observer = users.data;
      state.pagination.currentPage = users.meta.current_page;
      state.pagination.total = users.meta.last_page;
    },
    setUsersCount(state, count) {
      state.observerCount = count;
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    addError(state, { key, error }) {
      state.errors = {
        ...state.errors,
        [key]: error,
      };
    },
    clearErrors(state) {
      state.errors = [];
    },
    setSearch(state, search) {
      state.search = search;
    },
    setCurrentPage(state, currentPage) {
      state.pagination.currentPage = currentPage;
    },
    setCurrentUser(state, currentUser) {
      state.currentObserver = currentUser;
    },
    setCurrentValue(state, currentObserver) {
      Object.assign(state.currentObserver, currentObserver);
    },
    clearCurrentUser(state) {
      Object.keys(state.currentObserver).forEach(
        (key) => (state.currentObserver[key] = "")
      );
    },
    clearSearch(state) {
      state.search = "";
    },
    setAllAccess(state, access) {
      state.access = access;
    },
  },
  actions: {
    async fetchUsers({ commit, state }, { filters, sortBy }) {
      const { data } = await http.get("gatekeeper/observer", {
        params: {
          page: state.pagination.currentPage,
          search: state.search,
          ...filters,
          ...sortBy,
        },
      });
      const users = data.observer;
      commit("setUsers", users);
      commit("setUsersCount", users.meta.total);
    },

    async changeStatus(_, data) {
      return await http
        .post(`/gatekeeper/observer/${data.id}/change-status`, {
          status: data.status,
        })
        .then(() => {
          notify({
            type: "success",
            text: "messages.save.success",
            duration: 5000,
          });
        })
        .catch(({ response }) => {
          if (response && response.status === 422)
            notify({
              type: "danger",
              text: "messages.save.failure",
              duration: 5000,
            });
        });
    },

    async saveUser({ commit, state }) {
      return await http
        .post(`/gatekeeper/observer/store`, state.currentObserver)
        .then(() => {
          commit("clearErrors");
          commit("clearCurrentUser");
          notify({
            type: "success",
            text: "messages.save.success",
            duration: 5000,
          });
          router.push({ name: "ObserverList" });
        })
        .catch(({ response }) => {
          if (response && response.status === 422)
            commit("setErrors", response.data.errors);
          notify({
            type: "danger",
            text: "messages.save.failure",
            duration: 5000,
          });
        });
    },

    async updateUser({ commit, state }, id) {
      await http
        .post(`/gatekeeper/observer/${id}/update`, state.currentObserver)
        .then(() => {
          commit("clearErrors");
          notify({
            type: "success",
            text: "messages.edit.success",
            duration: 5000,
          });
          router.push({ name: "ObserverList" });
          commit("clearCurrentUser");
        })
        .catch(({ response }) => {
          if (response && response.status === 403) {
            notify({
              type: "danger",
              text: "messages.permission.failure",
              duration: 5000,
            });
            return;
          }
          if (response && response.status === 422) {
            commit("setErrors", response.data.errors);
            notify({
              type: "danger",
              text: "messages.edit.failure",
              duration: 5000,
            });
          }
        });
    },

    async getObserver({ commit }, id) {
      return await http
        .get(`gatekeeper/observer/${id}`)
        .then(({ data }) => {
          commit("setCurrentUser", data.admins);
        })
        .catch(({ response }) => {
          if (response && response.status === 403)
            notify({
              type: "danger",
              text: "messages.permission.failure",
              duration: 5000,
            });
        });
    },
    async fetchAccessList({ commit }) {
      const response = await http.get("/gatekeeper/observer/access");
      const access = response.data.access;
      commit("setAllAccess", access);
    },
  },
};
